import React from 'react';
import styles from './planet.module.css';

export default function Planet({ skills }) {
  return (
    <div className={styles.planetContainer}>
      <div className={styles.planet}></div>

      {skills && skills.map((skill, i) => (
        <p 
          key={i} 
          className={styles.floatingSkills}
          style={{ animationDelay: `${i * 3}s` }}
        >
          {skill}
        </p>
      ))}
    </div>
  );
}

